import { Author } from "@domain/lms/content";
import { CourseContent, CourseContentSummary } from "./courseContent";
import { CourseDraft } from "./courseDraft";

export const COURSE_VERSION = 2;

export const allCourseProviders = ["TOOSHARE", "UDEMY", "COURSERA"] as const;
export type CourseProvider = (typeof allCourseProviders)[number];

export const allCourseDurations = [
	"UNKNOWN",
	"MINUTES_0_TO_20",
	"MINUTES_20_TO_40",
	"MINUTES_40_TO_60",
	"MINUTES_MORE_THAN_60",
] as const;
export type CourseDuration = (typeof allCourseDurations)[number];

export interface FeedbackSummary {
	meanScore?: number;
	byMe: boolean;
}

export interface ShareSummary {
	byMe: boolean;
}
export interface ViewSummary {
	byMe: boolean;
	count: number;
}

export interface Course extends Omit<CourseDraft, "content" | "workspaceIds"> {
	id: string;
	author?: Author;
	provider: CourseProvider;
	publishedAt?: Date;
	lastUpdateDate: Date;
	reference: string | null;
	isFavorite: boolean;
	feedbacks: FeedbackSummary;
	shares: ShareSummary;
	views: ViewSummary;
	content: CourseContentSummary;
	slug: string;
	contentType: string;
}

export type LightCourse = Omit<Course, "content">;
export type DetailedCourse = Omit<LightCourse, "workspaceIds" | "content"> & {
	content: CourseContent;
};
